import type { FunctionComponent, ReactNode } from 'react'
import { createContext, useContext } from 'react'

interface ArticleContextProps {
  articleUrl?: string
  articleTitle?: string
}

const ArticleContext = createContext<ArticleContextProps>({})

export const useArticle = () => {
  const context = useContext(ArticleContext)
  return context
}

interface ArticleContextProviderProps {
  articleUrl?: string
  articleTitle?: string
  children: ReactNode
}

export const ArticleContextProvider: FunctionComponent<ArticleContextProviderProps> = ({
  articleUrl,
  articleTitle,
  children,
}) => {
  return (
    <ArticleContext.Provider value={{ articleUrl, articleTitle }}>
      {children}
    </ArticleContext.Provider>
  )
}